if (!window.OrganaxFeaturedProductsBound) {
  window.OrganaxFeaturedProductsBound = true;
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-featured-scroll]');
    if (!arrow) return;
    const rail = arrow.closest('.organax-featured')?.querySelector('.organax-featured__rail');
    if (!rail) return;
    const card = rail.querySelector('.organax-2026-products__card');
    const step = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).gap) || 0) : rail.clientWidth;
    rail.scrollBy({ left: step * (arrow.dataset.featuredScroll === 'next' ? 1 : -1), behavior: 'smooth' });
  });
}
